module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [(!_vm.isOffline) ? _c('div', {
    staticClass: "box-header text-center hidden-xs"
  }, [_c('div', {
    staticClass: "process-elem",
    attrs: {
      "id": "process-1"
    }
  }, [_vm._v("\n            建立 "), _c('div', {
    staticClass: "p-t-50"
  }, [_vm._v(_vm._s(_vm.orderList.create_time))])]), _vm._v(" "), _c('div', {
    staticClass: "process-elem",
    attrs: {
      "id": "process-2"
    }
  }, [_vm._v("\n            下訂 "), _c('div', {
    staticClass: "p-t-50"
  }, [_vm._v(_vm._s(_vm.orderList.order_time))])]), _vm._v(" "), _c('div', {
    staticClass: "process-elem",
    attrs: {
      "id": "process-3"
    }
  }, [_c('span', {
    class: {
      'text-worning': !_vm.orderList.settle_time && _vm.orderList.invoice_issue_time
    }
  }, [_vm._v("結帳")]), _vm._v(" "), _c('div', {
    staticClass: "p-t-50"
  }, [_vm._v(_vm._s(_vm.orderList.settle_time))])]), _vm._v(" "), _c('div', {
    staticClass: "process-elem",
    attrs: {
      "id": "process-4"
    }
  }, [_c('span', {
    class: {
      'text-worning': _vm.orderList.settle_time && !_vm.orderList.invoice_issue_time
    }
  }, [_vm._v("開立發票")]), _vm._v(" "), _c('div', {
    staticClass: "p-t-50"
  }, [_vm._v(_vm._s(_vm.orderList.invoice_issue_time))])]), _vm._v(" "), _c('div', {
    staticClass: "progress-block"
  }, [_c('div', {
    staticClass: "progress"
  }, [(_vm.orderList.invoice_issue_time) ? _c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }) : (_vm.orderList.settle_time) ? _c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "calc(100% / 3 * 2)"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }) : _c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "calc(100% / 3)"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left p-l-10 p-r-10-p"
  }, [_c('br'), _vm._v(" "), (!_vm.isOffline) ? _c('div', [_vm._m(0), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.allowance && _vm.orderList.allowance.length) ? _c('div', [_vm._m(1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getCouponList.length) ? _c('div', [_vm._m(2), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getPointList.length || _vm.getMembershipScore.length) ? _c('div', [_vm._m(3), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                " + _vm._s(_vm.isGuest ? 'POS機' : '') + "訂單編號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.isGuest ? _vm.orderList.pos_order_sn : _vm.orderList.order_sn || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.isGuest) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂單ID\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.order_id ? _vm.orderList.order_id : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂單狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('div', {
    staticClass: "status-light inline-block",
    class: _vm.orderStateColor(_vm.orderList.status)
  }), _vm._v(" "), _c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "line-height": "23px"
    }
  }, [_vm._v(" " + _vm._s(_vm.orderState(_vm.orderList.status)) + "(" + _vm._s(_vm.orderList.status) + ") ")]), _vm._v(" "), (_vm.roleType === 99 && !_vm.isOffline) ? _c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#editOrderStateModal"
    }
  }, [_vm._v("\n                  修改訂單狀態\n                ")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂購者"), (_vm.isGuest) ? _c('span', [_vm._v("姓名")]) : (_vm.roleType === 99) ? _c('span', [_vm._v("(ID)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info",
    class: {
      'text-red': _vm.orderList.shopper_black_info
    }
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.name ? _vm.orderList.name : '無資料')), (_vm.roleType === 99 && !_vm.isGuest) ? _c('span', [_vm._v("(" + _vm._s(_vm.orderList.shopper_id) + ")")]) : _vm._e(), _vm._v("  \n                "), (!_vm.isGuest) ? [_c('i', {
    staticClass: "fa c-pointer text-25",
    class: [_vm.orderList.shopper_black_info ? 'fa-frown-o' : 'fa-smile-o text-yellow'],
    staticStyle: {
      "top": "2.5px"
    },
    attrs: {
      "aria-hidden": "true",
      "data-toggle": "modal",
      "data-target": "#openModal"
    }
  })] : _vm._e(), _vm._v("\n                  \n                "), _c('router-link', {
    attrs: {
      "to": {
        path: '/memberOrderTable/' + _vm.orderList.shopper_id
      },
      "target": "_blank"
    }
  }, [((_vm.roleType === 99 || _vm.roleType === 30) && _vm.checkMemberShow(_vm.orderList.status)) ? _c('i', {
    staticClass: "fa fa-list-alt c-pointer text-primary text-25",
    staticStyle: {
      "top": "3.5px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂購者電話\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.phone ? _vm.orderList.phone : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.isOffline) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預定取餐時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.orderList.order_method === 2) ? _c('span', {
    staticClass: "label label-success",
    staticStyle: {
      "line-height": "25px"
    }
  }, [_vm._v("預")]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.orderList.delivery_reserv_time ? _vm.orderList.delivery_reserv_time : '無資料')), (_vm.orderList.delivery_reserv_tolerance) ? _c('span', [_vm._v(" ~ " + _vm._s(_vm.reservEndTime ? _vm.reservEndTime : '無資料'))]) : _vm._e()])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                取餐類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm._f("deliveryName")(_vm.orderList.delivery_type)) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.orderList.delivery_type === 21) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                桌號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.table_no || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.order_special_item_setting && Array.isArray(_vm.orderList.order_special_item_setting) && _vm.orderList.order_special_item_setting[0]) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                特殊需求\n              ")]), _vm._v(" "), (_vm.orderList.order_special_item_setting[0].value) ? _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.order_special_item_setting[0].turn_on_text) + "\n              ")]) : (!_vm.orderList.order_special_item_setting[0].value) ? _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.order_special_item_setting[0].turn_off_text) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.src_type && !_vm.isOffline) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂單來源\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderSource(_vm.orderList.src_type) ? _vm.orderSource(_vm.orderList.src_type) : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.sub_src_type && !_vm.isOffline) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂單瀏覽器來源\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.subSrcType ? _vm.subSrcType : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.delivery_type == 3 && !_vm.isOffline) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                外送地址\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.getShortAddress(_vm.orderList.address)
    }
  }, [_vm._v(_vm._s(_vm.orderList.address))])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.delivery_type == 3 && !_vm.isOffline) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預估與店家距離\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.distance / 1000) + " 公里\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.isOffline) ? _c('div', [_vm._m(4), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.notify_history && _vm.orderList.notify_history.length) ? _c('div', [_vm._m(5), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-block"
  }, [(!_vm.orderList.shopper_black_info && !_vm.isGuest) ? _c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#blackModal"
    }
  }, [_vm._v("\n                標記黑名單\n              ")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.shopper_black_info) ? _c('div', [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon bg-red",
    staticStyle: {
      "border": "1px solid #dd4b39"
    }
  }, [_vm._v("\n                    黑名單原因\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.getBReasonText(_vm.orderList.shopper_black_info.reason_type_id)) + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon bg-red",
    staticStyle: {
      "border": "1px solid #dd4b39"
    }
  }, [_vm._v("\n                    黑名單狀態\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.getBStatusText(_vm.orderList.shopper_black_info.status)) + "\n                  ")])]), _vm._v(" "), _c('br')])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right p-l-0"
  }, [_vm._m(6), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("品牌名稱(ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.brand_name) + "(" + _vm._s(_vm.orderList.brand_id) + ")\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("分店(ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://order.nidin.shop/menu/' + _vm.orderList.store_id
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderList.store_name) + "(" + _vm._s(_vm.orderList.store_id) + ")\n                ")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "visible-xs-block"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                下訂時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.order_time ? _vm.orderList.order_time : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                付款狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.payStateName(_vm.orderList.payment_status) ? _vm.payStateName(_vm.orderList.payment_status) : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                總份數\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.total_amount) + " 份\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                金額計算\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('p', {
    staticClass: "text-pay-list m-y-5 c-pointer"
  }, [_vm._v("\n                   商品 x " + _vm._s(_vm.orderList.total_amount) + "\n                  "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(" ＄" + _vm._s(_vm.orderList.total_money))])]), _vm._v(" "), (_vm.orderList.shipping_money) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }, [_vm._v("\n                   運費\n                  "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(" ＄" + _vm._s(_vm.orderList.shipping_money))])]) : _vm._e(), _vm._v(" "), (_vm.orderList.service_money) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }, [_vm._v("\n                   服務費\n                  "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("＄" + _vm._s(_vm.orderList.service_money))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orderList.payment_list), function(payment) {
    return (payment.method === 5 || payment.method === 31 || payment.method === 41) ? _c('p', {
      staticClass: "text-pay-list m-y-5"
    }, [_vm._v("\n                   " + _vm._s(payment.method === 31 ? '優惠券' : payment.method === 41 ? '電子票券' : payment.name) + "\n                  "), (payment.method === 31 || payment.method === 41) ? _c('button', {
      staticClass: "btn btn-default btn-sm m-l-5",
      on: {
        "click": function($event) {
          payment.method === 31 ? _vm.showCouponModal = true : _vm.showVoucherModal = true
        }
      }
    }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pull-right text-red"
    }, [_vm._v("- ＄" + _vm._s(payment.money))])]) : _vm._e()
  }), _vm._v(" "), (_vm.isOffline && _vm.combineCouponList.length) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }, [_vm._v("\n                   優惠券\n                  "), _c('button', {
    staticClass: "btn btn-default btn-sm m-l-5",
    on: {
      "click": function($event) {
        _vm.showOfflineCouponModal = true
      }
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red"
  }, [_vm._v("- ＄" + _vm._s(_vm.totalOfflineCouponMoney))])]) : _vm._e(), _vm._v(" "), (_vm.isOffline && _vm.combineVoucherList.length) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }, [_vm._v("\n                   電子票券\n                  "), _c('button', {
    staticClass: "btn btn-default btn-sm m-l-5",
    on: {
      "click": function($event) {
        _vm.showOfflineVoucherModal = true
      }
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red"
  }, [_vm._v("- ＄" + _vm._s(_vm.totalOfflineVoucherMoney))])]) : _vm._e(), _vm._v(" "), (_vm.orderList.discount && _vm.orderList.discount.total_discount) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }, [_vm._v("\n                   店家優惠\n                  "), _c('button', {
    staticClass: "btn btn-default btn-sm m-l-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#discountDetailModal"
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red"
  }, [_vm._v("- ＄" + _vm._s(_vm.orderList.discount.total_discount))])]) : _vm._e(), _vm._v(" "), (_vm.orderList.point && _vm.orderList.point.payment && _vm.orderList.point.payment.total_money) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }) : _vm._e(), _vm._l((_vm.orderList.point ? _vm.orderList.point.payment.list : []), function(p, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n                   點數\n                  "), _c('span', {
      staticClass: "pull-right text-red"
    }, [_vm._v("- ＄" + _vm._s(_vm.orderList.point.payment.total_money))])])
  }), _vm._v(" "), (_vm.orderList.point && _vm.orderList.point.payment && _vm.orderList.point.payment.list && _vm.orderList.point.payment.list.length === 0) ? _c('div', [_vm._v("\n                   點數\n                  "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("- ＄0")])]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), _vm._l((_vm.orderList.payment_list), function(payment) {
    return (payment.method === 6) ? _c('p', {
      staticClass: "text-pay-list m-y-5"
    }, [_vm._v("\n                   自備飲料杯折扣 x " + _vm._s(payment.total_cup_amount) + "\n                  "), _c('span', {
      staticClass: "pull-right text-red"
    }, [_vm._v("- ＄" + _vm._s(payment.money))])]) : _vm._e()
  }), _vm._v(" "), (_vm.orderList.membership_discount) ? _c('p', {
    staticClass: "text-pay-list m-y-5"
  }) : _vm._e(), _vm._l((_vm.membershipDiscount), function(m, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n                   " + _vm._s(_vm._f("discountText")(_vm.memberCardDiscount, true)) + "\n                  "), _c('span', {
      staticClass: "pull-right text-red"
    }, [_vm._v("- ＄" + _vm._s(m.total_discount))])])
  }), _vm._v(" "), _c('p')], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                總金額\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.total_paid_money) + " 元\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                付款類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.tradeType(_vm.orderList.trade_type) ? _vm.tradeType(_vm.orderList.trade_type) : '無資料') + " \n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.roleType === 99 && _vm.showTradeInfo) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                交易明細資訊\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#refundModal",
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.getTradeInfo
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 詳細內容\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.shopper_remark) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                購物者備註\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.shopper_remark || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.store_memo) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                店家備註\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.store_memo || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.store_remark) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                店家備註\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.store_remark || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.store_memo) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                店家訂單備註\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.store_memo || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.settle_time) ? _c('div', {
    staticClass: "visible-xs-block"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                結帳時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.settle_time) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.invoice_type) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                發票類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.invoiceType(_vm.orderList.invoice_type, _vm.orderList.email)) + " \n                "), (_vm.orderList.email) ? _c('span', [_vm._v(_vm._s(_vm.orderList.email))]) : _vm._e(), _vm._v(" "), (_vm.orderList.invoice_type === 20) ? _c('span', [_vm._v(_vm._s(_vm.orderList.invoice_carrier_id))]) : (_vm.orderList.invoice_type === 30) ? _c('span', [_vm._v(_vm._s(_vm.orderList.invoice_npoban_name) + " (" + _vm._s(_vm.orderList.invoice_npoban) + ")")]) : _vm._e()])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.isGuest) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                發票號碼\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.invoice_no ? _vm.orderList.invoice_no : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.orderList.invoice_issue_time) ? _c('div', {
    staticClass: "visible-xs-block"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                開立發票時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.invoice_issue_time) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.isGuest && !_vm.isOffline) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                統一編號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.ein || '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                更新時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.update_time ? _vm.orderList.update_time : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.isGuest) ? _c('div', {
    staticClass: "visible-xs-block"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                建立時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.create_time ? _vm.orderList.create_time : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.isGuest) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                POS機訂單編號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.pos_order_sn ? _vm.orderList.pos_order_sn : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                收銀機(櫃檯代號)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.pos_cashier_no ? _vm.orderList.pos_cashier_no : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                POS機當日交易序號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.pos_order_no ? _vm.orderList.pos_order_no : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.isGuest) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                POS機取餐號碼\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.orderList.pos_take_no ? _vm.orderList.pos_take_no : '無資料') + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 && (_vm.orderList.status == 3 || _vm.orderList.status == 100 || _vm.orderList.status == 2 || _vm.orderList.status == 1 || _vm.orderList.status == 100 || _vm.orderList.status == 110 || _vm.orderList.status == 120 || _vm.orderList.status == 122 || _vm.orderList.status == 130 || _vm.orderList.status == 140)) ? _c('div', {
    staticClass: "btn-block"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.orderList.status == 3 || _vm.orderList.status == 100) ? _c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#resendOrderNotifyModal"
    }
  }, [_vm._v("\n                重新發送通知給店家\n              ")]) : _vm._e(), _vm._v(" "), (_vm.orderList.status == 2 || _vm.orderList.status == 3) ? _c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#refundOrderModal"
    }
  }, [_vm._v("\n                訂單退款\n              ")]) : _vm._e(), _vm._v(" "), (_vm.orderList.status == 1 || _vm.orderList.status == 2 || _vm.orderList.status == 3) ? _c('button', {
    staticClass: "btn btn-danger m-r-5 m-y-5",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#cancelShopperOrderModal"
    }
  }, [_vm._v("\n                取消訂購者訂單\n              ")]) : _vm._e(), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), (_vm.bindingShipping) ? _c('div', {
    staticClass: "box-body form-center text-center"
  }, [_c('hr')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping) ? _c('div', {
    staticClass: "box-body form-left p-l-10 p-r-10-p"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                報價狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "line-height": "23px"
    }
  }, [_vm._v(" " + _vm._s(_vm.quotedState(_vm.bindingShipping.quoted_status)) + "(" + _vm._s(_vm.bindingShipping.quoted_status) + ") ")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.bindingShipping.status_reason) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                叫件失敗原因\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "line-height": "23px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.bindingShipping.status_reason) + "\n                ")])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預計取件時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.expected_get_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預計送達時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.expected_arrived_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.bindingShipping.advance_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                代收貨款費\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.advance_money) + " 元\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping.vendor_fee_remark) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                手續費\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.vendor_fee_remark) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping) ? _c('div', {
    staticClass: "box-body form-right p-l-0"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                物流業者\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm._f("shippingVendorName")(_vm.bindingShipping.vendor_code)) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                物流預估距離\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.distance) + " 公尺\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.bindingShipping.weight) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                物流預估重量\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.weight) + " 公克\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping.vendor_code && _vm.bindingShipping.vendor_code == 'glo') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預估運費報價\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.total_fee) + " 元\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping.vendor_code && _vm.bindingShipping.vendor_code.includes('mete')) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預估外送員運費\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.total_fee) + " 元 / 位\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping.vendor_quoted_no) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                物流報價單號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.vendor_quoted_no) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping.driver_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                外送員人數\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.driver_amount) + " 位\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping.remark) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                叫件備註\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.bindingShipping.remark) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.bindingShipping && _vm.bindingShipping.status >= 100 && _vm.bindingShipping.vendor_code != 'glo') ? _c('div', {
    staticClass: "col-xs-12 hint"
  }, [_vm._v("\n          系統將會優先媒合外送員1，若其餘外送員長時間顯示無資料，請聯絡物流客服。\n        ")]) : _vm._e(), _vm._v(" "), (_vm.bindingShipping) ? _c('div', {
    staticClass: "w-100 box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable no-footer"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [(_vm.bindingShipping.status < 100) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("尚未叫件")])]) : _vm._l((_vm.shippingCaseList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("外送員" + _vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.driver_name || '-')), (item.driver_code) ? _c('span', [_vm._v("(" + _vm._s(item.driver_code) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.driver_phone || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.delivery_platform_name || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.customer_order_no || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.actual_get_time || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.actual_arrived_time || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.total_fee || '-'))]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm.shippingStateColor(item.status)
    }, [_vm._v(_vm._s(_vm._f("shippingStatusName")(item.status)))])]), _vm._v(" "), _c('td', [(item.customer_order_no) ? _c('a', {
      attrs: {
        "data-target": "#driverTimeModal",
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.driverTimeDialog = item
        }
      }
    }, [_vm._v("查看時間狀態")]) : _c('span', [_vm._v("-")])])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.ratingList.length) ? _c('div', {
    staticClass: "box-body form-center text-center"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(8), _vm._v(" "), (_vm.ratingList) ? _c('tbody', _vm._l((_vm.ratingList), function(rating, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [(rating.is_main) ? _c('span', {
      staticClass: "text-danger text-bold"
    }, [_c('i', {
      staticClass: "fa fa-fire",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" 最新")]) : _vm._e()]), _vm._v(" "), _c('td', {
      class: rating.star > 3 ? 'text-success' : 'text-danger'
    }, [_c('i', {
      staticClass: "fa fa-star",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(rating.star))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rating.comment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rating.reply_comment))]), _vm._v(" "), _c('td', [(rating.is_main) ? _c('button', {
      staticClass: "btn btn-default",
      class: {
        'btn-success': !rating.is_replied
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#ratingModal"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(rating)
        }
      }
    }, [(rating.is_replied) ? _c('span', [_vm._v("修改")]) : _c('span', [_vm._v("回覆")]), _vm._v("評價\n                    ")]) : _vm._e()])])
  }), 0) : _vm._e()])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "openModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("會員暱稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [(_vm.orderList.shopper_black_info) ? _c('span', [_c('label', {
    staticClass: "label label-danger"
  }, [_vm._v("黑名單")]), _vm._v(" ")]) : _vm._e(), _vm._v("\n                  " + _vm._s(_vm.orderList.shopper_nickname) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("會員手機")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.orderList.shopper_phone))])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.roleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("會員信箱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.orderList.shopper_email))])]), _vm._v(" "), _c('br')]) : _vm._e()])])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.blackOption,
      "selectOptions": _vm.bSelectOptions
    },
    on: {
      "trigger": _vm.trigger,
      "selectOnChange": _vm.changeBlackReason
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.resendOrderNotifyOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.refundOrderOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.cancelShopperOrderOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.cancelPosOrderOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.editOrderStateOption,
      "selectOptions": _vm.selectOptions
    },
    on: {
      "trigger": _vm.trigger,
      "selectOnChange": _vm.selectOnChange,
      "inputOnChange": _vm.inputOnChange
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.forceRefundOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "discountDetailModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(11), _vm._v(" "), (_vm.orderList.discount) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sorting_1 v-middle text-left bg-dark-gray text-white",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_vm._v("\n                          -$" + _vm._s(_vm.orderList.discount.total_discount) + "\n                        ")])])]), _vm._v(" "), _vm._l((_vm.orderList.discount.list), function(discount, i) {
    return _c('tr', {
      key: ("product-" + i),
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1 v-middle text-center"
    }, [_vm._v("\n                        " + _vm._s(i + 1) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "v-middle"
    }, [(discount.activity_name) ? _c('div', [_vm._v("\n                          ◎活動名稱：" + _vm._s(discount.activity_name) + "\n                        ")]) : _vm._e(), _vm._v(" "), (discount.start_date && discount.end_date) ? _c('div', [_vm._v("\n                          ◎活動時間：" + _vm._s(discount.start_date) + " ~ " + _vm._s(discount.end_date) + "\n                        ")]) : _vm._e(), _vm._v(" "), (discount.activity_description) ? _c('div', [_vm._v("\n                          ◎活動說明：" + _vm._s(discount.activity_description) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                          ◎折扣碼：" + _vm._s(discount.exchange_code || '無') + "\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("-$" + _vm._s(discount.total_discount))])])
  })], 2)])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "orderDetailModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "flex justify-end"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sorting_1 v-middle text-left bg-dark-gray text-white",
    attrs: {
      "colspan": _vm.productCouponList.length || _vm.productVoucherList.length ? 4 : 3
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderList.name) + "\n                        "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("\n                          ＄" + _vm._s(_vm.orderList.money) + "\n                          "), (_vm.productCouponList.length || _vm.productVoucherList.length) ? _c('span', {
    staticClass: "c-pointer",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#couponModal"
    },
    on: {
      "click": function($event) {
        _vm.info = _vm.orderList;
        _vm.showCouponVoucherModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ticket text-red",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])])]), _vm._v(" "), _vm._l((_vm.productList), function(p, i) {
    return _c('tr', {
      key: ("product-" + i),
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1 v-middle text-center"
    }, [_vm._v("\n                        " + _vm._s(i + 1) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "flex row"
    }, [_c('div', [_c('h4', [_vm._v("\n                            " + _vm._s(p.product) + " - ＄" + _vm._s(p.total_money / p.amount) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "product-option"
    }, [_vm._l((p.option_list), function(option, j) {
      return (p.type === 1) ? _c('span', {
        key: ("option-" + j)
      }, [_vm._v("\n                              " + _vm._s(option) + "\n                              "), (j < p.option_list.length - 1) ? _c('span', [_vm._v(" / ")]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((p.product_list), function(pList, k) {
      return (p.type === 3) ? _c('span', {
        key: ("pList-" + k)
      }, _vm._l((pList), function(prod, l) {
        return _c('span', {
          key: ("prod-" + l)
        }, [_c('span', [_vm._v("\n                                  " + _vm._s(prod.product) + "\n                                ")]), _vm._v(" "), (prod.amount > 1) ? _c('span', [_vm._v("\n                                  x" + _vm._s(prod.amount) + "\n                                ")]) : _vm._e(), _vm._v(" "), _vm._l((prod.option_list), function(opt, m) {
          return (prod.type === 1) ? _c('span', {
            key: ("opt-" + m)
          }, [(m === 0) ? _c('span', [_vm._v("：")]) : _vm._e(), _vm._v("\n                                  " + _vm._s(opt) + "\n                                  "), (m < prod.option_list.length - 1) ? _c('span', [_vm._v(" / ")]) : _vm._e()]) : _vm._e()
        }), _vm._v(" "), _c('br')], 2)
      }), 0) : _vm._e()
    })], 2), _vm._v(" "), (p.cup_amount) ? _c('p', {
      staticClass: "flex"
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/icon/i_reusable_cup_black.svg")
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "product-option p-l-5"
    }, [_vm._v("自備飲料杯 x" + _vm._s(p.cup_amount))])]) : _vm._e(), _vm._v(" "), (p.sticker_name) ? _c('p', [_c('span', [_c('i', {
      staticClass: "fa fa-user",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                              " + _vm._s(p.sticker_name) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (p.custom_remark) ? _c('p', [_c('i', {
      staticClass: "fa fa-quote-left",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                            " + _vm._s(p.custom_remark) + "\n                          ")]) : _vm._e()]), _vm._v(" "), (p.amount) ? _c('div', {
      staticClass: "m-l-auto"
    }, [_c('h4', {
      staticClass: "text-right text-bold text-nowrap"
    }, [_vm._v("x " + _vm._s(p.amount))])]) : _vm._e()]), _vm._v(" "), (!_vm.productCouponList.length || !_vm.productVoucherList.length) ? _c('td', [_c('h4', {
      staticClass: "text-right text-bold text-nowrap"
    }, [_vm._v("$" + _vm._s(p.total_money))])]) : _vm._e(), _vm._v(" "), (_vm.productCouponList.length || _vm.productVoucherList.length) ? _c('td', [_c('h4', {
      staticClass: "text-right text-bold"
    }, [_vm._v("$" + _vm._s(p.total_money))]), _vm._v(" "), (_vm.productCouponMap[p.item_set_uid]) ? _c('div', {
      staticClass: "flex align-center justify-between"
    }, [_c('label', {
      staticClass: "label label-default bg-blue mb-0"
    }, [_vm._v("優惠券")]), _vm._v(" "), _c('span', {
      staticClass: "product-option"
    }, [_vm._v(" -$" + _vm._s(_vm.productCouponMap[p.item_set_uid].total_discount))])]) : _vm._e(), _vm._v(" "), (_vm.productVoucherMap[p.item_set_uid]) ? _c('div', {
      staticClass: "flex align-center justify-between"
    }, [_c('label', {
      staticClass: "label label-default bg-blue mb-0"
    }, [_vm._v("電子票券")]), _vm._v(" "), _c('span', {
      staticClass: "product-option"
    }, [_vm._v(" -$" + _vm._s(_vm.productVoucherMap[p.item_set_uid].total_discount))])]) : _vm._e()]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _vm._l((_vm.orderList.group_buy_follower_order_list), function(follower, i) {
    return (_vm.orderList.order_type === 2) ? _c('div', {
      key: ("follower-" + i),
      staticClass: "col-sm-12 table-responsive p-x-0"
    }, [_c('table', {
      staticClass: "table table-bordered table-striped dataTable",
      attrs: {
        "aria-describedby": "example1_info",
        "role": "grid",
        "id": "example2"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "sorting_1 text-left bg-dark-gray text-white",
      attrs: {
        "colspan": follower.coupon_list.length || follower.voucher_list.length ? 4 : 3
      }
    }, [_vm._v("\n                        " + _vm._s(follower.contact_name) + "\n                        "), (follower.is_guest_order === 1) ? _c('span', [_vm._v("（非會員）")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("\n                          ＄" + _vm._s(follower.money) + "\n                          "), (follower.coupon_list.length || follower.voucher_list.length) ? _c('span', {
      staticClass: "c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#couponModal"
      },
      on: {
        "click": function($event) {
          _vm.info = follower;
          _vm.showCouponVoucherModal = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ticket text-red",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()])])]), _vm._v(" "), _vm._l((follower.product_list), function(p, index) {
      return _c('tr', {
        attrs: {
          "role": "row"
        }
      }, [_c('td', {
        staticClass: "sorting_1 text-center"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('h4', [_vm._v(_vm._s(p.product) + " - ＄" + _vm._s(p.total_money / p.amount))]), _vm._v(" "), _c('p', {
        staticClass: "product-option"
      }, [_vm._l((p.option_list), function(option, index) {
        return (p.type === 1) ? _c('span', [_vm._v("\n                            " + _vm._s(option) + " "), (index < p.option_list.length - 1) ? _c('span', [_vm._v(" / ")]) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), _vm._l((p.product_list), function(pList) {
        return (p.type === 3) ? _c('span', _vm._l((pList), function(prod) {
          return _c('span', [_c('span', [_vm._v(_vm._s(prod.product))]), (prod.amount > 1) ? _c('span', [_vm._v("x" + _vm._s(prod.amount))]) : _vm._e(), _vm._l((prod.option_list), function(opt, i) {
            return (prod.type === 1) ? _c('span', [(i === 0) ? _c('span', [_vm._v("：")]) : _vm._e(), _vm._v(_vm._s(opt)), (i < prod.option_list.length - 1) ? _c('span', [_vm._v(" / ")]) : _vm._e()]) : _vm._e()
          }), _vm._v(" "), _c('br')], 2)
        }), 0) : _vm._e()
      })], 2), _vm._v(" "), (p.cup_amount) ? _c('p', {
        staticClass: "flex"
      }, [_c('img', {
        attrs: {
          "src": require("../../../assets/icon/i_reusable_cup_black.svg")
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "product-option p-l-5"
      }, [_vm._v("自備飲料杯 x" + _vm._s(p.cup_amount))])]) : _vm._e(), _vm._v(" "), (p.sticker_name) ? _c('p', [_c('span', [_c('i', {
        staticClass: "fa fa-user",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v("\n                            " + _vm._s(p.sticker_name) + "\n                          ")])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('h4', {
        staticClass: "text-right text-bold text-nowrap"
      }, [_vm._v("x " + _vm._s(p.amount))])]), _vm._v(" "), (follower.coupon_list.length || follower.voucher_list.length) ? _c('td', [_c('h4', {
        staticClass: "text-right text-bold"
      }, [_vm._v("$" + _vm._s(p.total_money))]), _vm._v(" "), (follower.product_coupon_list.item_list && follower.product_coupon_list.item_list[p.item_set_uid]) ? _c('div', {
        staticClass: "flex align-center justify-between"
      }, [_c('label', {
        staticClass: "label label-default bg-blue mb-0"
      }, [_vm._v("優惠券")]), _vm._v(" "), _c('span', {
        staticClass: "product-option"
      }, [_vm._v(" -$" + _vm._s(follower.product_coupon_list.item_list[p.item_set_uid].total_discount))])]) : _vm._e(), _vm._v(" "), (follower.product_voucher_list.item_list && follower.product_voucher_list.item_list[p.item_set_uid]) ? _c('div', {
        staticClass: "flex align-center justify-between"
      }, [_c('label', {
        staticClass: "label label-default bg-blue mb-0"
      }, [_vm._v("電子票券")]), _vm._v(" "), _c('span', {
        staticClass: "product-option"
      }, [_vm._v(" -$" + _vm._s(follower.product_voucher_list.item_list[p.item_set_uid].total_discount))])]) : _vm._e()]) : _vm._e()])
    })], 2), _vm._v(" "), _c('br')])]) : _vm._e()
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "couponDetailModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead'), _vm._v(" "), _c('tbody', _vm._l((_vm.couponList), function(c, cIndex) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1 v-middle text-center"
    }, [_vm._v(_vm._s(cIndex + 1))]), _vm._v(" "), _c('td', {
      staticClass: "v-middle"
    }, [_c('h4', [_vm._v(_vm._s(c.name) + " - " + _vm._s(c.coupon_set_code))]), _vm._v(" "), _c('p', {
      staticClass: "product-option"
    }, [_c('span', [_vm._v("\n                            " + _vm._s(_vm.priceTypeName(c.price_type)) + "\n                          ")])])]), _vm._v(" "), _c('td', {
      staticClass: "v-middle text-right"
    }, [_vm._v("x " + _vm._s(c.amount))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "text-right bg-dark-gray text-white"
  }, [_c('td', {
    staticClass: "text-w-600",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("$ " + _vm._s(_vm.totalCouponMoney))])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "getCouponDetailModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead'), _vm._v(" "), _c('tbody', _vm._l((_vm.getCouponList), function(c, cIndex) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1 v-middle text-center"
    }, [_vm._v(_vm._s(cIndex + 1))]), _vm._v(" "), _c('td', {
      staticClass: "v-middle"
    }, [_c('h4', [_vm._v(_vm._s(c.name) + " - " + _vm._s(c.coupon_set_code))]), _vm._v(" "), _c('p', {
      staticClass: "product-option"
    }, [_c('span', [_vm._v("\n                            " + _vm._s(_vm.priceTypeName(c.price_type)) + "\n                          ")])])]), _vm._v(" "), _c('td', {
      staticClass: "v-middle"
    }, [_vm._v("\n                        " + _vm._s(_vm.valueName(c.discount_value, c.discount_type)) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "v-middle text-right"
    }, [_vm._v("x " + _vm._s(c.amount))])])
  }), 0)])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "getPointDetailModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('tbody', [(Object.keys(_vm.groupedPoints).length) ? _c('tr', [_c('td', {
    staticClass: "sorting_1 v-middle text-left bg-dark-gray text-white",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                        獲得點數\n                      ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupedPoints), function(group, src_type, index) {
    return _c('tr', {
      key: src_type
    }, [(group.length) ? _c('td', {
      staticClass: "text-center vertical-m",
      attrs: {
        "rowspan": "group.length"
      }
    }, [_vm._v("\n                        " + _vm._s(index + 1) + "\n                      ")]) : _vm._e(), _vm._v(" "), (group.length) ? _c('td', {
      staticClass: "vertical-m",
      attrs: {
        "rowspan": "group.length",
        "width": "150px"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.getSrcTypeName('point', src_type)) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "p-0",
      attrs: {
        "rowspan": "group.length"
      }
    }, _vm._l((group), function(point, index) {
      return _c('div', {
        key: point.point_id,
        staticClass: "dialog-border"
      }, [_vm._v("\n                            " + _vm._s(point.point_brand_name ? point.point_brand_name : '你訂') + _vm._s(point.point_store_name ? point.point_store_name : '') + "點數\n                        ")])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "p-0",
      attrs: {
        "rowspan": "group.length"
      }
    }, _vm._l((group), function(point, index) {
      return _c('div', {
        key: point.point_id,
        staticClass: "flex dialog-border justify-end"
      }, [_vm._v(_vm._s(point.amount) + " (點)")])
    }), 0)])
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('tbody', [(Object.keys(_vm.groupedMembershipScore).length) ? _c('tr', [_c('td', {
    staticClass: "sorting_1 v-middle text-left bg-dark-gray text-white",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                        獲得積分\n                      ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupedMembershipScore), function(group, src_type, index) {
    return _c('tr', {
      key: src_type
    }, [(group.length) ? _c('td', {
      staticClass: "text-center vertical-m",
      attrs: {
        "rowspan": "group.length"
      }
    }, [_vm._v("\n                        " + _vm._s(index + 1) + "\n                      ")]) : _vm._e(), _vm._v(" "), (group.length) ? _c('td', {
      staticClass: "vertical-m",
      attrs: {
        "rowspan": "group.length",
        "width": "150px"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.getSrcTypeName('memberScore', src_type)) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "p-0",
      attrs: {
        "rowspan": "group.length"
      }
    }, _vm._l((group), function(item, index) {
      return _c('div', {
        key: 's_' + index,
        staticClass: "dialog-border"
      }, [_vm._v("\n                        " + _vm._s(item.membership_group_brand_name ? item.membership_group_brand_name : '你訂') + _vm._s(item.membership_group_store_name ? item.membership_group_store_name : '') + "積分\n                      ")])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "p-0",
      attrs: {
        "rowspan": "group.length"
      }
    }, _vm._l((group), function(item, index) {
      return _c('div', {
        key: item.point_id,
        staticClass: "flex dialog-border justify-end"
      }, [_vm._v(_vm._s(item.amount) + " (積分)")])
    }), 0)])
  })], 2)])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "statusTrackingModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.orderList.status_tracking), function(tracking, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(tracking.create_time) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(_vm.orderState(tracking.status)) + "\n                    ")])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "notifyHistoryModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.orderList.notify_history), function(history, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(history.create_time) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(_vm.notifyType(history.type)) + "\n                    ")]), _vm._v(" "), _c('td', [(history.is_notified) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("已發送")]) : _vm._e(), _vm._v(" "), (!history.is_notified) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未發送")]) : _vm._e()])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "allowanceModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog text-left"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.orderList.allowance), function(allowance, aIndex) {
    return _c('p', [_vm._v("\n            " + _vm._s(aIndex + 1) + ".  購買"), _vm._l((allowance.menu_name_group), function(prod, pIndex) {
      return _c('span', [_vm._v(_vm._s(prod)), (pIndex + 1 < allowance.menu_name_group.length) ? _c('span', [_vm._v("、")]) : _vm._e()])
    }), _vm._v("折" + _vm._s(allowance.total_allowance / allowance.match_amount) + "元\n             "), _c('span', {
      staticClass: "label label-primary",
      staticStyle: {
        "top": "-2px"
      }
    }, [_vm._v("符合 " + _vm._s(allowance.match_amount) + " 組")]), _vm._v("，"), _c('span', {
      staticClass: "label label-danger",
      staticStyle: {
        "top": "-2px"
      }
    }, [_vm._v("共折 " + _vm._s(allowance.total_allowance) + " 元")])], 2)
  }), 0), _vm._v(" "), _vm._m(19)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "driverTimeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [(_vm.driverTimeDialog) ? _c('tbody', [(_vm.driverTimeDialog.create_time) ? _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.driverTimeDialog.create_time))]), _vm._v(" "), _c('td', [_vm._v("成立物流單")])]) : _vm._e(), _vm._v(" "), (_vm.driverTimeDialog.vendor_confirm_time) ? _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.driverTimeDialog.vendor_confirm_time))]), _vm._v(" "), _c('td', [_vm._v("物流接單")])]) : _vm._e(), _vm._v(" "), (_vm.driverTimeDialog.store_cancel_time) ? _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.driverTimeDialog.store_cancel_time))]), _vm._v(" "), _c('td', [_vm._v("門市取消叫件")])]) : _vm._e(), _vm._v(" "), (_vm.driverTimeDialog.vendor_cancel_time && _vm.driverTimeDialog.status != 900) ? _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.driverTimeDialog.vendor_cancel_time))]), _vm._v(" "), _c('td', [_vm._v("媒合失敗")])]) : _vm._e(), _vm._v(" "), (_vm.driverTimeDialog.actual_get_time) ? _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.driverTimeDialog.actual_get_time))]), _vm._v(" "), _c('td', [_vm._v("已取貨")])]) : _vm._e(), _vm._v(" "), (_vm.driverTimeDialog.actual_arrived_time) ? _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.driverTimeDialog.actual_arrived_time))]), _vm._v(" "), _c('td', [_vm._v("已送達")])]) : _vm._e()]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "ratingModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [(_vm.ratingInfo.is_replied) ? _c('span', [_vm._v("修改")]) : _c('span', [_vm._v("回覆")]), _vm._v("評價")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('p', [_vm._v(_vm._s(_vm.ratingInfo.comment))]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v(_vm._s(_vm.ratingInfo.create_time))])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratingInfo.reply_comment),
      expression: "ratingInfo.reply_comment"
    }],
    staticClass: "w-100-p p-10",
    staticStyle: {
      "min-height": "250px"
    },
    domProps: {
      "value": (_vm.ratingInfo.reply_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ratingInfo, "reply_comment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v(_vm._s(_vm.ratingInfo.reply_time))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.defaultComment(1)
      }
    }
  }, [_vm._v("感謝支持")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.defaultComment(2)
      }
    }
  }, [_vm._v("抱歉")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.defaultComment(3)
      }
    }
  }, [_vm._v("已聯絡")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.reply
    }
  }, [_vm._v("確定"), (_vm.ratingInfo.is_replied) ? _c('span', [_vm._v("修改")]) : _c('span', [_vm._v("回覆")])])])])])]), _vm._v(" "), (_vm.showCouponVoucherModal) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-content coupon-modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCouponVoucherModal = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("詳情")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "400px"
    }
  }, [(_vm.info.coupon_list && _vm.info.coupon_list.length) ? [_c('h5', {
    staticClass: "text-bold "
  }, [_vm._v("優惠券")]), _vm._v(" "), _c('ol', [_vm._l((_vm.infoProductCouponFormat), function(productCoupon) {
    return _vm._l((productCoupon.formatList), function(coupon) {
      return _c('li', {
        staticClass: "mb-2"
      }, [_c('div', {
        staticClass: "d-flex align-center"
      }, [_c('span', {
        staticClass: "label label-default mb-0"
      }, [_vm._v(_vm._s(coupon.productName))]), _vm._v(" "), _c('span', {
        staticClass: "m-l-5"
      }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
        staticClass: "label label-primary m-l-5 mb-0"
      }, [_vm._v(_vm._s(coupon.count) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
        staticClass: "label label-danger mb-0"
      }, [_vm._v("共折" + _vm._s(coupon.count * coupon.unitDiscount) + "元")])])])
    })
  }), _vm._v(" "), _vm._l((_vm.info.coupon_list.filter(function (i) { return !i.product_name; })), function(coupon) {
    return _c('li', {
      staticClass: "mb-2"
    }, [_c('div', {
      staticClass: "d-flex align-center"
    }, [_c('span', {
      staticClass: "label label-default mb-0"
    }, [_vm._v(_vm._s(coupon.product_name))]), _vm._v(" "), _c('span', {
      staticClass: "m-l-5"
    }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
      staticClass: "label label-primary m-l-5 mb-0"
    }, [_vm._v(_vm._s(coupon.amount) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
      staticClass: "label label-danger mb-0"
    }, [_vm._v("共折" + _vm._s(coupon.money) + "元")])])])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.info.coupon_list && _vm.info.coupon_list.length && _vm.info.voucher_list && _vm.info.voucher_list.length) ? _c('hr', {
    staticStyle: {
      "margin": "1.5em 0"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.info.voucher_list && _vm.info.voucher_list.length) ? [_c('h5', {
    staticClass: "text-bold "
  }, [_vm._v("電子票券")]), _vm._v(" "), _c('ol', [_vm._l((_vm.infoVoucherCouponFormat), function(VoucherCoupon) {
    return _vm._l((VoucherCoupon.formatList), function(coupon) {
      return _c('li', {
        staticClass: "mb-2"
      }, [_c('div', {
        staticClass: "d-flex align-center"
      }, [_c('span', {
        staticClass: "label label-default mb-0"
      }, [_vm._v(_vm._s(coupon.productName))]), _vm._v(" "), _c('span', {
        staticClass: "m-l-5"
      }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
        staticClass: "label label-primary m-l-5 mb-0"
      }, [_vm._v(_vm._s(coupon.count) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
        staticClass: "label label-danger mb-0"
      }, [_vm._v("共折" + _vm._s(coupon.count * coupon.unitDiscount) + "元")])])])
    })
  })], 2)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCouponVoucherModal = false
      }
    }
  }, [_vm._v("返回")])])])]) : _vm._e(), _vm._v(" "), (_vm.showCouponModal) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-content coupon-modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCouponModal = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("優惠券核銷詳情")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "400px"
    }
  }, [_c('ol', [_vm._l((_vm.productCouponListFormat), function(productCoupon) {
    return _vm._l((productCoupon.formatList), function(coupon) {
      return _c('li', {
        staticClass: "mb-2"
      }, [_c('div', {
        staticClass: "d-flex align-center"
      }, [_c('span', {
        staticClass: "label label-default mb-0"
      }, [_vm._v(_vm._s(coupon.productName))]), _vm._v(" "), _c('span', {
        staticClass: "m-l-5"
      }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
        staticClass: "label label-primary m-l-5 mb-0"
      }, [_vm._v(_vm._s(coupon.count) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
        staticClass: "label label-danger mb-0"
      }, [_vm._v("共折" + _vm._s(coupon.count * coupon.unitDiscount) + "元")])])])
    })
  }), _vm._v(" "), _vm._l((_vm.gbProductCouponListFormat), function(gbProductCoupon) {
    return _vm._l((gbProductCoupon.formatList), function(coupon) {
      return _c('li', {
        staticClass: "mb-2"
      }, [_c('div', {
        staticClass: "d-flex align-center"
      }, [_c('span', {
        staticClass: "label label-default mb-0"
      }, [_vm._v(_vm._s(coupon.productName))]), _vm._v(" "), _c('span', {
        staticClass: "m-l-5"
      }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
        staticClass: "label label-primary m-l-5 mb-0"
      }, [_vm._v(_vm._s(coupon.count) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
        staticClass: "label label-danger mb-0"
      }, [_vm._v("共折" + _vm._s(coupon.count * coupon.unitDiscount) + "元")])])])
    })
  }), _vm._v(" "), _vm._l((_vm.couponListWithoutProduct), function(coupon) {
    return _c('li', {
      staticClass: "mb-2"
    }, [_c('div', {
      staticClass: "d-flex align-center"
    }, [_c('span', {
      staticClass: "label label-default mb-0"
    }, [_vm._v(_vm._s(coupon.product_name))]), _vm._v(" "), _c('span', {
      staticClass: "m-l-5"
    }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
      staticClass: "label label-primary m-l-5 mb-0"
    }, [_vm._v(_vm._s(coupon.amount) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
      staticClass: "label label-danger mb-0"
    }, [_vm._v("共折" + _vm._s(coupon.money) + "元")])])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showVoucherModal) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-content coupon-modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showVoucherModal = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("電子票券核銷詳情")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ol', [_vm._l((_vm.voucherCouponListFormat), function(voucherCoupon) {
    return _vm._l((voucherCoupon.formatList), function(coupon) {
      return _c('li', {
        staticClass: "mb-2"
      }, [_c('div', {
        staticClass: "d-flex align-center"
      }, [_c('span', {
        staticClass: "label label-default mb-0"
      }, [_vm._v(_vm._s(coupon.productName))]), _vm._v(" "), _c('span', {
        staticClass: "m-l-5"
      }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
        staticClass: "label label-primary m-l-5 mb-0"
      }, [_vm._v(_vm._s(coupon.count) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
        staticClass: "label label-danger mb-0"
      }, [_vm._v("共折" + _vm._s(coupon.count * coupon.unitDiscount) + "元")])])])
    })
  }), _vm._v(" "), _vm._l((_vm.gbVoucherCouponListFormat), function(gbVoucherCoupon) {
    return _vm._l((gbVoucherCoupon.formatList), function(coupon) {
      return _c('li', {
        staticClass: "mb-2"
      }, [_c('div', {
        staticClass: "d-flex align-center"
      }, [_c('span', {
        staticClass: "label label-default mb-0"
      }, [_vm._v(_vm._s(coupon.productName))]), _vm._v(" "), _c('span', {
        staticClass: "m-l-5"
      }, [_vm._v("使用")]), _vm._v(" "), _c('span', {
        staticClass: "label label-primary m-l-5 mb-0"
      }, [_vm._v(_vm._s(coupon.count) + "張" + _vm._s(coupon.name))]), _vm._v("，"), _c('span', {
        staticClass: "label label-danger mb-0"
      }, [_vm._v("共折" + _vm._s(coupon.count * coupon.unitDiscount) + "元")])])])
    })
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showProductModal) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-content product-modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showProductModal = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("產品優惠券")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.info.list), function(product, pIndex) {
    return _c('p', [_vm._v("\n          " + _vm._s(pIndex + 1) + ".  使用 "), _c('span', {
      staticClass: "label label-primary",
      staticStyle: {
        "top": "-2px"
      }
    }, [_vm._v(_vm._s(product.name))]), _vm._v("，"), _c('span', {
      staticClass: "label label-danger",
      staticStyle: {
        "top": "-2px"
      }
    }, [_vm._v("共折" + _vm._s(product.unit_discount) + "元")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showProductModal = false
      }
    }
  }, [_vm._v("返回")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon bg-blue",
    staticStyle: {
      "border": "1px solid #0073b7"
    }
  }, [_vm._v("\n                產品明細\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#orderDetailModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 產品內容\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon bg-blue",
    staticStyle: {
      "border": "1px solid #0073b7"
    }
  }, [_vm._v("\n                折讓金額\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#allowanceModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 折讓內容\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon bg-blue",
    staticStyle: {
      "border": "1px solid #0073b7"
    }
  }, [_vm._v("\n                獲得優惠券明細\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#getCouponDetailModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 獲得優惠券內容\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon bg-blue",
    staticStyle: {
      "border": "1px solid #0073b7"
    }
  }, [_vm._v("\n                獲得點數/積分明細\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#getPointDetailModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 獲得內容\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訂單狀態紀錄\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#statusTrackingModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 詳細內容\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                門市通知紀錄\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#notifyHistoryModal",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 詳細內容\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hidden-xs hidden-sm"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("外送員編號")]), _vm._v(" "), _c('th', [_vm._v("外送員(代碼)")]), _vm._v(" "), _c('th', [_vm._v("外送員電話")]), _vm._v(" "), _c('th', [_vm._v("物流廠商")]), _vm._v(" "), _c('th', [_vm._v("物流查詢編號")]), _vm._v(" "), _c('th', [_vm._v("實際取貨時間")]), _vm._v(" "), _c('th', [_vm._v("實際送達時間")]), _vm._v(" "), _c('th', [_vm._v("運費(元)")]), _vm._v(" "), _c('th', [_vm._v("物流狀態")]), _vm._v(" "), _c('th', [_vm._v("物流時間狀態")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("星級")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("留言")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("回覆")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "refundModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box-body form text-left"
  }, [_c('pre', {
    attrs: {
      "id": "trade-info"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("店家優惠")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("產品明細")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("優惠券明細")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("獲得優惠券明細")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("獲得點數/積分明細")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("訂單狀態紀錄")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("門市通知紀錄")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("商品優惠")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("物流狀態時間")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b0a08de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Order/OrderInfo.vue
// module id = 2312
// module chunks = 1